import React from "react";
import CoverPhoto from "@/sot/primitives/CoverPhoto.jsx";
import AvatarHeaderPositioned from "@/sot/primitives/AvatarHeaderPositioned.jsx";

/**
 * Read-only profile media frame for Institution detail routes. The caller owns
 * all actions; this component deliberately contains no media mutation affordance.
 */
export default function InstitutionProfileCover({
  src = "",
  fallbackSrc,
  children,
  avatarSrc = "",
  avatarAlt = "Profile",
  heightClassName = "h-[190px] sm:h-[220px] md:h-[280px] lg:h-[320px]",
  avatarOffsetClassName,
  avatarRailClassName,
  avatarPlaceholderSrc,
  avatarContent = null,
  className = "",
}) {
  const [displaySrc, setDisplaySrc] = React.useState(src || fallbackSrc);

  React.useEffect(() => {
    setDisplaySrc(src || fallbackSrc);
  }, [fallbackSrc, src]);

  return (
    <div className={`relative profile-cover-bleed ${className}`.trim()}>
      <CoverPhoto
        src={displaySrc || fallbackSrc}
        heightClassName={heightClassName}
        onImageError={() => {
          if (displaySrc !== fallbackSrc) setDisplaySrc(fallbackSrc);
        }}
      />
      <div className="absolute inset-x-0 top-0">
        <div className="afrimed-page pt-2">
          {children}
        </div>
      </div>
      {avatarContent || <AvatarHeaderPositioned
        previewUrl={avatarSrc}
        alt={avatarAlt}
        interactive={false}
        showEditChip={false}
        mobileOffsetClassName={avatarOffsetClassName}
        railClassName={avatarRailClassName}
        placeholderSrc={avatarPlaceholderSrc}
      />}
    </div>
  );
}
